import { useState } from 'react';

import { stripWhitespace } from '../helpers';

export default (initialVals = {}) => {
  const [values, setValues] = useState(initialVals);
  const handleChange = ev => {
    const { name, value, type } = ev.target;
    let cleansedValue = value;
    if (type === 'email') {
      cleansedValue = stripWhitespace(cleansedValue);
    }

    if (name === 'area_level_1') {
      setValues({ ...values, area_level_2: 'all', [name]: cleansedValue });
    } else {
      setValues({ ...values, [name]: cleansedValue });
    }
  };
  return { values, handleChange };
};
